
export interface LicensingInfo {
  State: string;
  Applicable: string;
  StateWebsite: string;
  ApplyWebsite: string;
  LicensingBoard: string;
  Comments: string;
}

export const licensingData: LicensingInfo[] = [
  // ------------------------
  // Original snippet (U.S.)
  // ------------------------
  {
    State: "Alabama",
    Applicable: "",
    StateWebsite: "https://www.alabama.gov/",
    ApplyWebsite: "https://bels.alabama.gov/",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Alaska",
    Applicable: "",
    StateWebsite: "https://alaska.gov/",
    ApplyWebsite: "https://www.commerce.alaska.gov/web/cbpl/ProfessionalLicensing/BoardofArchitectsEngineersandLandSurveyors.aspx",
    LicensingBoard: "https://my.alaska.gov/adfs/ls/?wa=wsignin1.0&wtrealm=... ",
    Comments: ""
  },
  {
    State: "American Samoa",
    Applicable: "",
    StateWebsite: "https://www.americansamoa.gov/",
    ApplyWebsite: "This U.S. territory is the only jurisdiction that doesn't license professional engineers",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Arizona",
    Applicable: "",
    StateWebsite: "https://az.gov/",
    ApplyWebsite: "https://btr.az.gov/engineer-applicants",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Wyoming",
    Applicable: "",
    StateWebsite: "https://www.wyo.gov/",
    ApplyWebsite: "https://engineersandsurveyors.wyo.gov/",
    LicensingBoard: "",
    Comments: ""
  },

  // ------------------------
  // Africa
  // ------------------------
  {
    State: "Algeria",
    Applicable: "Voluntary Association",
    StateWebsite: "Association des Ingénieurs d'Etat Diplômés de l'Institut Algérien du Pétrole (AIED-IAP)",
    ApplyWebsite: "http://www.aied-iap.com/",
    LicensingBoard: "http://www.aied-iap.com/membre.php",
    Comments: "This looks like a very old website, last update 2018?"
  },
  {
    State: "Angola",
    Applicable: "Registering Body",
    StateWebsite: "ALL",
    ApplyWebsite: "www.ordemengenheiros.ao; https://oea.ordemengenheiros.ao/AdmissaoOrdem.aspx",
    LicensingBoard: "www.ordemengenheiros.ao",
    Comments: ""
  },
  {
    State: "Benin",
    Applicable: "Unknown",
    StateWebsite: "",
    ApplyWebsite: "",
    LicensingBoard: "Not found",
    Comments: ""
  },
  {
    State: "Botswana",
    Applicable: "Registering Body",
    StateWebsite: "ALL",
    ApplyWebsite: "www.erb.org.bw",
    LicensingBoard: "www.erb.org.bw",
    Comments: ""
  },
  {
    State: "Burkina Faso",
    Applicable: "Unknown",
    StateWebsite: "",
    ApplyWebsite: "",
    LicensingBoard: "Not found",
    Comments: ""
  },
  {
    State: "Burundi",
    Applicable: "Unknown",
    StateWebsite: "",
    ApplyWebsite: "",
    LicensingBoard: "Not found",
    Comments: ""
  },
  {
    State: "Cabo Verde",
    Applicable: "Unknown",
    StateWebsite: "",
    ApplyWebsite: "",
    LicensingBoard: "Not found",
    Comments: ""
  },
  {
    State: "Cameroon",
    Applicable: "Unknown",
    StateWebsite: "",
    ApplyWebsite: "",
    LicensingBoard: "Not found",
    Comments: ""
  },
  {
    State: "Central African Republic",
    Applicable: "Unknown",
    StateWebsite: "",
    ApplyWebsite: "",
    LicensingBoard: "Not found",
    Comments: ""
  },
  {
    State: "Chad",
    Applicable: "Unknown",
    StateWebsite: "",
    ApplyWebsite: "",
    LicensingBoard: "Not found",
    Comments: ""
  },
  {
    State: "Comoros",
    Applicable: "Unknown",
    StateWebsite: "",
    ApplyWebsite: "",
    LicensingBoard: "Not found",
    Comments: ""
  },
  {
    State: "Congo",
    Applicable: "Unknown",
    StateWebsite: "ALL",
    ApplyWebsite: "None found",
    LicensingBoard: "https://www.the-cae.org/",
    Comments: "Professional eng resource website"
  },
  {
    State: "Côte d'Ivoire",
    Applicable: "Unknown",
    StateWebsite: "",
    ApplyWebsite: "",
    LicensingBoard: "Not found",
    Comments: ""
  },
  {
    State: "Djibouti",
    Applicable: "Unknown",
    StateWebsite: "",
    ApplyWebsite: "",
    LicensingBoard: "Not found",
    Comments: ""
  },
  {
    State: "DR Congo",
    Applicable: "Unknown",
    StateWebsite: "",
    ApplyWebsite: "",
    LicensingBoard: "Not found",
    Comments: ""
  },
  {
    State: "Egypt",
    Applicable: "Unknown",
    StateWebsite: "",
    ApplyWebsite: "",
    LicensingBoard: "Not found",
    Comments: ""
  },
  {
    State: "Equatorial Guinea",
    Applicable: "Unknown",
    StateWebsite: "ALL",
    ApplyWebsite: "None found",
    LicensingBoard: "https://ypenergy.org/equatorial-quinea/",
    Comments: "Young professionals website"
  },
  {
    State: "Eritrea",
    Applicable: "Unknown",
    StateWebsite: "",
    ApplyWebsite: "",
    LicensingBoard: "Not found",
    Comments: ""
  },
  {
    State: "Eswatini",
    Applicable: "Registering Body",
    StateWebsite: "ALL",
    ApplyWebsite: "www.aesap.net",
    LicensingBoard: "www.aesap.net",
    Comments: "Registration Council for Architects, Engineers, Surveyors and Allied Professionals (AESAP)"
  },
  {
    State: "Ethiopia",
    Applicable: "Unknown",
    StateWebsite: "",
    ApplyWebsite: "",
    LicensingBoard: "Not found",
    Comments: ""
  },
  {
    State: "Gabon",
    Applicable: "Unknown",
    StateWebsite: "",
    ApplyWebsite: "",
    LicensingBoard: "Not found",
    Comments: ""
  },
  {
    State: "Gambia",
    Applicable: "Unknown",
    StateWebsite: "",
    ApplyWebsite: "",
    LicensingBoard: "Not found",
    Comments: ""
  },
  {
    State: "Ghana",
    Applicable: "Registering Body",
    StateWebsite: "ALL",
    ApplyWebsite: "ghie.org.gh",
    LicensingBoard: "ghie.org.gh",
    Comments: "Ghana Institution of Engineers (GhIE)"
  },
  {
    State: "Guinea",
    Applicable: "Unknown",
    StateWebsite: "",
    ApplyWebsite: "",
    LicensingBoard: "Not found",
    Comments: ""
  },
  {
    State: "Guinea-Bissau",
    Applicable: "Unknown",
    StateWebsite: "",
    ApplyWebsite: "",
    LicensingBoard: "Not found",
    Comments: ""
  },
  {
    State: "Kenya",
    Applicable: "Registering Body",
    StateWebsite: "ALL",
    ApplyWebsite: "https://ebk.go.ke/professional-engineer-registration/?tk=1683656519",
    LicensingBoard: "https://ebk.go.ke/",
    Comments: "Engineers Board of Kenya (EBK)"
  },
  {
    State: "Lesotho",
    Applicable: "Unknown",
    StateWebsite: "",
    ApplyWebsite: "",
    LicensingBoard: "Not found",
    Comments: ""
  },
  {
    State: "Liberia",
    Applicable: "Unknown",
    StateWebsite: "",
    ApplyWebsite: "",
    LicensingBoard: "Not found",
    Comments: ""
  },
  {
    State: "Libya",
    Applicable: "Unknown",
    StateWebsite: "",
    ApplyWebsite: "",
    LicensingBoard: "Not found",
    Comments: ""
  },
  {
    State: "Madagascar",
    Applicable: "Registering Body",
    StateWebsite: "ALL",
    ApplyWebsite: "www.ingenieurs-mg.org/",
    LicensingBoard: "www.ingenieurs-mg.org/",
    Comments: "l'Ordre des Ingénieurs de Madagascar (OIM)"
  },
  {
    State: "Malawi",
    Applicable: "Registering Body",
    StateWebsite: "ALL",
    ApplyWebsite: "web.facebook.com/Malawi-Board-of-Engineers-1039997...",
    LicensingBoard: "web.facebook.com/Malawi-Board-of-Engineers-1039997...",
    Comments: "(BoE)"
  },
  {
    State: "Mali",
    Applicable: "Unknown",
    StateWebsite: "",
    ApplyWebsite: "",
    LicensingBoard: "Not found",
    Comments: ""
  },
  {
    State: "Mauritania",
    Applicable: "Unknown",
    StateWebsite: "Société Mauritanienne des Hydrocarbures/Ministry of Peroleum Mines and Energy Mauritanides",
    ApplyWebsite: "",
    LicensingBoard: "Not found",
    Comments: ""
  },
  {
    State: "Mauritius",
    Applicable: "Registering Body",
    StateWebsite: "ALL",
    ApplyWebsite: "www.crpemauritius.com",
    LicensingBoard: "www.crpemauritius.com",
    Comments: "Council of Registered Professional Engineers of Mauritius (CRPE)"
  },
  {
    State: "Morocco",
    Applicable: "Unknown",
    StateWebsite: "None found",
    ApplyWebsite: "None found",
    LicensingBoard: "Not found",
    Comments: "None found"
  },
  {
    State: "Mozambique",
    Applicable: "Registering Body",
    StateWebsite: "ALL",
    ApplyWebsite: "www.ordeng.org.mz",
    LicensingBoard: "www.ordeng.org.mz",
    Comments: "Ordemo dos Engenheiros of Mozambique (OEM)"
  },
  {
    State: "Namibia",
    Applicable: "Registering Body",
    StateWebsite: "ALL",
    ApplyWebsite: "www.ecn.org.na",
    LicensingBoard: "www.ecn.org.na",
    Comments: "Engineering Council of Namibia (ECN)"
  },
  {
    State: "Niger",
    Applicable: "Unknown",
    StateWebsite: "",
    ApplyWebsite: "",
    LicensingBoard: "Not found",
    Comments: ""
  },
  {
    State: "Nigeria",
    Applicable: "Voluntary Association",
    StateWebsite: "ALL",
    ApplyWebsite: "https://www.coren.gov.ng/; Oil & Gasspenigeria.spe.org",
    LicensingBoard: "Requirements & COREN Membership. Council for the Regulation of Engineering in Nigeria (COREN)",
    Comments: "COREN has rights to control/regulate engineers in the country."
  },
  {
    State: "Rwanda",
    Applicable: "Registering Body",
    StateWebsite: "ALL",
    ApplyWebsite: "www.engineersrwanda.rw",
    LicensingBoard: "www.engineersrwanda.rw",
    Comments: "Institution of Engineers Rwanda (IER)"
  },
  {
    State: "Sao Tome & Principe",
    Applicable: "Unknown",
    StateWebsite: "",
    ApplyWebsite: "",
    LicensingBoard: "Not found",
    Comments: ""
  },
  {
    State: "Senegal",
    Applicable: "Unknown",
    StateWebsite: "",
    ApplyWebsite: "",
    LicensingBoard: "Not found",
    Comments: ""
  },
  {
    State: "Seychelles",
    Applicable: "Unknown",
    StateWebsite: "",
    ApplyWebsite: "",
    LicensingBoard: "Not found",
    Comments: ""
  },
  {
    State: "Sierra Leone",
    Applicable: "Unknown",
    StateWebsite: "",
    ApplyWebsite: "",
    LicensingBoard: "Not found",
    Comments: ""
  },
  {
    State: "Somalia",
    Applicable: "Unknown",
    StateWebsite: "",
    ApplyWebsite: "",
    LicensingBoard: "Not found",
    Comments: ""
  },
  {
    State: "South Africa",
    Applicable: "Registering Body",
    StateWebsite: "ALL",
    ApplyWebsite: "www.ecsa.co.za",
    LicensingBoard: "www.ecsa.co.za",
    Comments: "Engineering Council of South Africa (ECSA)"
  },
  {
    State: "South Sudan",
    Applicable: "Registering Body",
    StateWebsite: "ALL",
    ApplyWebsite: "0",
    LicensingBoard: "0",
    Comments: "Engineering Council of Southern Sudan (ECOSS)"
  },
  {
    State: "Sudan",
    Applicable: "Registering Body",
    StateWebsite: "ALL",
    ApplyWebsite: "www.sdac.gov.sd/index.php/en/home",
    LicensingBoard: "www.sdac.gov.sd/index.php/en/home",
    Comments: "Sudanese Accreditation Council"
  },
  {
    State: "Tanzania",
    Applicable: "Registering Body",
    StateWebsite: "ALL",
    ApplyWebsite: "www.erb.go.tz",
    LicensingBoard: "www.erb.go.tz",
    Comments: "Engineers Registration Board of Tanzania (ERB)"
  },
  {
    State: "Togo",
    Applicable: "Unknown",
    StateWebsite: "",
    ApplyWebsite: "",
    LicensingBoard: "Not found",
    Comments: ""
  },
  {
    State: "Tunisia",
    Applicable: "Unknown",
    StateWebsite: "",
    ApplyWebsite: "",
    LicensingBoard: "Not found",
    Comments: ""
  },
  {
    State: "Uganda",
    Applicable: "Registering Body",
    StateWebsite: "ALL",
    ApplyWebsite: "www.erb.go.ug",
    LicensingBoard: "www.erb.go.ug",
    Comments: "Engineers Registration Board (ERB)"
  },
  {
    State: "Zambia",
    Applicable: "Registering Body",
    StateWebsite: "ALL",
    ApplyWebsite: "www.eiz.org.zm",
    LicensingBoard: "www.eiz.org.zm",
    Comments: "Engineers' Registration Board (EngRB)"
  },
  {
    State: "Zimbabwe",
    Applicable: "Registering Body",
    StateWebsite: "ALL",
    ApplyWebsite: "www.ecz.co.zw",
    LicensingBoard: "www.ecz.co.zw",
    Comments: "Engineering Council of Zimbabwe (ECZ)"
  },

  // ------------------------
  // Australia & New Zealand
  // ------------------------
  {
    State: "Queensland",
    Applicable: "Y",
    StateWebsite: "https://www.professionalengineers.org.au/rpeng/",
    ApplyWebsite: "https://www.bpeq.qld.gov.au/registration/become-a-rpeq/",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "New South Wales",
    Applicable: "N",
    StateWebsite: "https://www.service.nsw.gov.au/",
    ApplyWebsite: "https://www.service.nsw.gov.au/transaction/apply-professional-engineer-registration",
    LicensingBoard: "",
    Comments: "Looks like it caters to building engineers only"
  },
  {
    State: "Northern Territory",
    Applicable: "Y",
    StateWebsite: "https://www.professionalengineers.org.au/rpeng/",
    ApplyWebsite: "https://www.rpeng.org.au/RPEng/Victoria/Apply/RPENG/Content/Application/RPEV_Sign_up.aspx?hkey=f0de71af-81cb-46b2-9bfb-97faebe388ec",
    LicensingBoard: "https://www.rpeng.org.au/RPEng/Victoria/Victorian_Registration/RPENG/Content/Resources/Victorian_Registration.aspx?hkey=4b445f71-dfbe-4831-9371-9266057e343a",
    Comments: ""
  },
  {
    State: "Victoria",
    Applicable: "Y",
    StateWebsite: "https://www.professionalengineers.org.au/rpeng/",
    ApplyWebsite: "https://www.rpeng.org.au/RPEng/Victoria/Apply/RPENG/Content/Application/RPEV_Sign_up.aspx?hkey=f0de71af-81cb-46b2-9bfb-97faebe388ec",
    LicensingBoard: "https://www.rpeng.org.au/RPEng/Victoria/Victorian_Registration/RPENG/Content/Resources/Victorian_Registration.aspx?hkey=4b445f71-dfbe-4831-9371-9266057e343a",
    Comments: ""
  },
  {
    State: "Western Australia",
    Applicable: "N",
    StateWebsite: "https://www.commerce.wa.gov.au/",
    ApplyWebsite: "https://www.commerce.wa.gov.au/building-and-energy/licensing-and-registration-and-owner-builder-approval",
    LicensingBoard: "https://www.commerce.wa.gov.au/announcements/commerce-minister-statement-western-australia-steps-closer-registration-building",
    Comments: "Looks like it caters to building engineers only"
  },
  {
    State: "Australia",
    Applicable: "Y",
    StateWebsite: "https://www.engineersaustralia.org.au/ ; https://www.rpeng.org.au/RPENG",
    ApplyWebsite: "https://www.engineersaustralia.org.au/credentials/registration/state-registration/assessment-state-registration ; https://www.rpeng.org.au/RPEng/RPEng/Apply/RPENG/Content/Application/Sign_up.aspx?hkey=be9e2a71-fd5e-426a-81d7-524369f5d46d",
    LicensingBoard: "https://www.engineersaustralia.org.au/sites/default/files/2022-07/petroleum_engineering_aop_aoe_-_final.pdf",
    Comments: "Four-year accredited Bachelor degree is required in an engineering discipline. RPEng is a national accreditation scheme administered by Professionals Australia."
  },
  {
    State: "New Zealand",
    Applicable: "Y",
    StateWebsite: "https://www.engineeringnz.org/",
    ApplyWebsite: "https://www.engineeringnz.org/join-us/cpeng/",
    LicensingBoard: "https://www.engineeringnz.org/join-us/#membership-types",
    Comments: "Engineering New Zealand is a non-profit membership organisation."
  },

  // ------------------------
  // East Asia
  // ------------------------
  {
    State: "China",
    Applicable: "NA",
    StateWebsite: "",
    ApplyWebsite: "https://www.theiet.org/search/?cof=FORID%3A11&q=china",
    LicensingBoard: "https://www.theiet.org/membership/",
    Comments: "No Chinese websites found that register PEs. Possibly IET (International)."
  },
  {
    State: "Hong Kong (1)",
    Applicable: "NA",
    StateWebsite: "https://www.erb.org.hk/",
    ApplyWebsite: "https://www.erb.org.hk/notestoapplicants.htm",
    LicensingBoard: "",
    Comments: "Hong Kong's engineering registration board website"
  },
  {
    State: "Hong Kong (2)",
    Applicable: "NA",
    StateWebsite: "",
    ApplyWebsite: "https://www.theiet.org/search/?cof=FORID%3A11&q=hong+kong",
    LicensingBoard: "https://www.theiet.org/membership/",
    Comments: "International Institute for registration of engineers"
  },
  {
    State: "Taiwan",
    Applicable: "",
    StateWebsite: "https://law.moj.gov.tw/",
    ApplyWebsite: "https://law.moj.gov.tw/ENG/LawClass/LawAll.aspx?pcode=J0030022",
    LicensingBoard: "",
    Comments: "No specific site for licensing. Engineers must pass an engineering exam (per law.moj.gov)."
  },
  {
    State: "Japan",
    Applicable: "NA",
    StateWebsite: "https://www.engineer.or.jp/sub09/",
    ApplyWebsite: "https://www.engineer.or.jp/c_topics/000/000345.html",
    LicensingBoard: "",
    Comments: "No national PE regulation. Possibly not recognized for petroleum engineering specifically."
  },
  {
    State: "Mongolia",
    Applicable: "NA",
    StateWebsite: "",
    ApplyWebsite: "",
    LicensingBoard: "",
    Comments: "No websites found."
  },
  {
    State: "North Korea",
    Applicable: "NA",
    StateWebsite: "",
    ApplyWebsite: "",
    LicensingBoard: "",
    Comments: "No websites found."
  },
  {
    State: "South Korea",
    Applicable: "Y",
    StateWebsite: "https://www.kpea.or.kr",
    ApplyWebsite: "https://www.kpea.or.kr/kpea/english/overivew.html",
    LicensingBoard: "https://www.kpea.or.kr/kpea/english/Mutual_Recognition_Agreement.html; https://www.kpea.or.kr/kpea/english/Testing_Method_and_Implementation.html",
    Comments: ""
  },

  // ------------------------
  // South Asia & Southeast Asia
  // ------------------------
  {
    State: "Bangladesh",
    Applicable: "Y",
    StateWebsite: "http://box2490.temp.domains/~bperbieb/",
    ApplyWebsite: "http://box2490.temp.domains/~bperbieb/",
    LicensingBoard: "https://remondas.blogspot.com/2019/07/how-to-get-recognition-of-professional.html",
    Comments: ""
  },
  {
    State: "Bhutan",
    Applicable: "Y",
    StateWebsite: "https://www.ecob.gov.bt/",
    ApplyWebsite: "https://www.ecob.gov.bt/?page_id=136",
    LicensingBoard: "",
    Comments: "Engineering Council of Bhutan"
  },
  {
    State: "India",
    Applicable: "Y",
    StateWebsite: "https://www.ieindia.org/",
    ApplyWebsite: "https://www.ieindia.org/webui/IEI_PE_Certification.aspx",
    LicensingBoard: "https://www.theiet.org/search?q=INDIA",
    Comments: "IET also has presence in India"
  },
  {
    State: "Maldives",
    Applicable: "Y",
    StateWebsite: "ALL",
    ApplyWebsite: "",
    LicensingBoard: "https://www.omicsonline.org/societies/association-of-maldivian-engineers-professional-engineering-organisation/",
    Comments: "Civil engineering mention"
  },
  {
    State: "Nepal",
    Applicable: "Y",
    StateWebsite: "https://nec.gov.np/",
    ApplyWebsite: "https://nec.gov.np/pages/Professional/",
    LicensingBoard: "",
    Comments: "Nepal Engineering Council for registration"
  },
  {
    State: "Pakistan",
    Applicable: "Y",
    StateWebsite: "https://pec.org.pk/",
    ApplyWebsite: "https://portal.pec.org.pk/",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Sri Lanka",
    Applicable: "Y",
    StateWebsite: "https://www.ecsl.lk/",
    ApplyWebsite: "https://www.ecsl.lk/pages/registration-of-non-engineering-technicians",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Brunei",
    Applicable: "Y",
    StateWebsite: "http://www.bapeqs.gov.bn",
    ApplyWebsite: "http://www.bapeqs.gov.bn/SitePages/Registration/",
    LicensingBoard: "http://acpecc.net/",
    Comments: "Websites sometimes not working"
  },
  {
    State: "Burma (Myanmar)",
    Applicable: "Y",
    StateWebsite: "https://www.myanmarengc.org/",
    ApplyWebsite: "http://www.bapeqs.gov.bn/SitePages/Registration.aspx",
    LicensingBoard: "http://acpecc.net/",
    Comments: ""
  },
  {
    State: "Cambodia",
    Applicable: "Y",
    StateWebsite: "http://www.bec.gov.kh/en/",
    ApplyWebsite: "http://www.bec.gov.kh/en/member",
    LicensingBoard: "http://acpecc.net/",
    Comments: ""
  },
  {
    State: "Timor-Leste",
    Applicable: "NA",
    StateWebsite: "NA",
    ApplyWebsite: "",
    LicensingBoard: "",
    Comments: "New country (2002)"
  },
  {
    State: "Indonesia",
    Applicable: "Y",
    StateWebsite: "https://www.pipi.or.id/about/",
    ApplyWebsite: "https://www.pipi.or.id/certification/",
    LicensingBoard: "http://acpecc.net/",
    Comments: ""
  },
  {
    State: "Laos",
    Applicable: "Y",
    StateWebsite: "",
    ApplyWebsite: "",
    LicensingBoard: "http://acpecc.net/",
    Comments: "See ASEAN website."
  },
  {
    State: "Malaysia",
    Applicable: "Y",
    StateWebsite: "http://bem.org.my/professional-engineer",
    ApplyWebsite: "http://bem.org.my/web/guest/professional-engineeer-with-practising-certificate",
    LicensingBoard: "http://acpecc.net/",
    Comments: "Petronas note: 'I am not aware of any requirements...' But we found official sites."
  },
  {
    State: "Philippines",
    Applicable: "Y",
    StateWebsite: "https://www.prc.gov.ph/",
    ApplyWebsite: "https://www.prc.gov.ph/professional-regulatory-boards",
    LicensingBoard: "http://acpecc.net/",
    Comments: "See ASEAN website below."
  },
  {
    State: "Singapore",
    Applicable: "Y",
    StateWebsite: "https://www.peb.gov.sg/",
    ApplyWebsite: "https://www.peb.gov.sg/pe_reg_intro.aspx",
    LicensingBoard: "http://acpecc.net/",
    Comments: "Also see ASEAN website."
  },
  {
    State: "Thailand",
    Applicable: "Y",
    StateWebsite: "https://en.coe.or.th/",
    ApplyWebsite: "https://service.coe.or.th/",
    LicensingBoard: "http://acpecc.net/",
    Comments: "Also see ASEAN website."
  },
  {
    State: "Vietnam",
    Applicable: "NA",
    StateWebsite: "NA",
    ApplyWebsite: "See ASEAN website",
    LicensingBoard: "http://acpecc.net/",
    Comments: "Also see ASEAN website below."
  },

  // ------------------------
  // Europe
  // ------------------------
  {
    State: "Andorra",
    Applicable: "",
    StateWebsite: "",
    ApplyWebsite: "",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Austria",
    Applicable: "Yes",
    StateWebsite: "https://www.oiav.at/",
    ApplyWebsite: "https://www.oiav.at/mitgliedschaft/",
    LicensingBoard: "Österreichischer Ingenieur-und Architekten-Verein",
    Comments: ""
  },
  {
    State: "Belgium",
    Applicable: "N/A",
    StateWebsite: "http://www.fabi.be/",
    ApplyWebsite: "",
    LicensingBoard: "FABI",
    Comments: "(Fédération Royale des Associations Belges d'Ingénieurs civils...)"
  },
  {
    State: "Denmark",
    Applicable: "N/A",
    StateWebsite: "www.ida.dk",
    ApplyWebsite: "https://ida.dk/bliv-medlem",
    LicensingBoard: "Ingeniørforeningen i Danmark (IDA)",
    Comments: ""
  },
  {
    State: "Finland",
    Applicable: "",
    StateWebsite: "https://www.ilry.fi",
    ApplyWebsite: "https://www.ilry.fi/en/become-a-member/",
    LicensingBoard: "Insinöörilitto",
    Comments: ""
  },
  {
    State: "France",
    Applicable: "N/A",
    StateWebsite: "http://www.iesf.fr",
    ApplyWebsite: "",
    LicensingBoard: "Ingénieurs et Scientifiques de France (IESF)",
    Comments: ""
  },
  {
    State: "Germany",
    Applicable: "N/A",
    StateWebsite: "http://www.dvt-net.de/",
    ApplyWebsite: "",
    LicensingBoard: "Deutsches Nationalkomitee der FEANI",
    Comments: ""
  },
  {
    State: "Greece",
    Applicable: "Yes",
    StateWebsite: "http://portal.tee.gr/portal/page/portal/TEE/MyTEE",
    ApplyWebsite: "https://web.tee.gr/tmima-mitroon/",
    LicensingBoard: "Technical Chamber of Greece",
    Comments: "https://web.tee.gr/tmima-mitroon/"
  },
  {
    State: "Iceland",
    Applicable: "Yes",
    StateWebsite: "http://www.vfi.is",
    ApplyWebsite: "https://www.vfi.is/um-vfi/felagsadild/",
    LicensingBoard: "Association of Chartered Engineers of Iceland",
    Comments: ""
  },
  {
    State: "Ireland",
    Applicable: "Yes",
    StateWebsite: "http://www.engineersireland.ie",
    ApplyWebsite: "https://www.engineersireland.ie/Professionals/Membership/Become-a-member",
    LicensingBoard: "Engineers Ireland",
    Comments: ""
  },
  {
    State: "Italy",
    Applicable: "Yes",
    StateWebsite: "www.tuttoingegnere.it",
    ApplyWebsite: "",
    LicensingBoard: "Consiglio Nazionale Ingegneri",
    Comments: ""
  },
  {
    State: "Liechtenstein",
    Applicable: "",
    StateWebsite: "",
    ApplyWebsite: "",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Luxembourg",
    Applicable: "",
    StateWebsite: "https://guichet.public.lu/en/entreprises/creation-developpement/autorisation-etablissement/profession-liberale/ingenieur-independant.html",
    ApplyWebsite: "",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Malta",
    Applicable: "Yes",
    StateWebsite: "http://www.coe.org.mt",
    ApplyWebsite: "https://www.coe.org.mt/membership/",
    LicensingBoard: "Chamber of Engineers",
    Comments: ""
  },
  {
    State: "Monaco",
    Applicable: "",
    StateWebsite: "",
    ApplyWebsite: "",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Netherlands",
    Applicable: "N/A",
    StateWebsite: "https://www.kivi.nl/",
    ApplyWebsite: "https://www.kivi.nl/formulieren/aanmelden-kivi-lidmaatschap",
    LicensingBoard: "Royal Netherlands Society of Engineers (KIVI)",
    Comments: ""
  },
  {
    State: "Norway",
    Applicable: "N/A",
    StateWebsite: "https://www.nito.no/",
    ApplyWebsite: "https://www.nito.no/medlemsfordel/",
    LicensingBoard: "Norwegian National Committee for FEANI",
    Comments: ""
  },
  {
    State: "Portugal",
    Applicable: "Yes",
    StateWebsite: "https://www.ordemengenheiros.pt/pt/",
    ApplyWebsite: "https://www.ordemengenheiros.pt/pt/admissao-a-ordem/",
    LicensingBoard: "Portuguese National Committee for FEANI",
    Comments: ""
  },
  {
    State: "San Marino",
    Applicable: "",
    StateWebsite: "",
    ApplyWebsite: "",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Spain",
    Applicable: "N/A",
    StateWebsite: "http://www.consejominas.org/",
    ApplyWebsite: "",
    LicensingBoard: "Ordem dos Engenheiros (?)",
    Comments: ""
  },
  {
    State: "Sweden",
    Applicable: "N/A",
    StateWebsite: "www.sverigesingenjorer.se",
    ApplyWebsite: "https://www.sverigesingenjorer.se/bli-medlem/",
    LicensingBoard: "Sveriges Ingenjörer",
    Comments: ""
  },
  {
    State: "Switzerland",
    Applicable: "N/A",
    StateWebsite: "www.sia.ch",
    ApplyWebsite: "https://www.sia.ch/en/membership/",
    LicensingBoard: "SIA",
    Comments: ""
  },
  {
    State: "Turkey",
    Applicable: "Yes",
    StateWebsite: "https://pmo.org.tr/",
    ApplyWebsite: "",
    LicensingBoard: "https://www.tmmob.org.tr/en/page/about",
    Comments: "Union of Chambers of Turkish Engineers and Architects"
  },
  {
    State: "United Kingdom",
    Applicable: "Yes",
    StateWebsite: "https://www.energyinst.org/",
    ApplyWebsite: "https://www.energyinst.org/membership-and-careers/membership",
    LicensingBoard: "The Engineering Council is the regulatory authority for Chartered engineers.",
    Comments: ""
  },

  // ------------------------
  // Central & South America
  // ------------------------
  {
    State: "Argentina",
    Applicable: "NA",
    StateWebsite: "All",
    ApplyWebsite: "https://www.colegioingenieros2.org.ar/web/index.php?start=11",
    LicensingBoard: "https://www.colegioingenieros2.org.ar/web/index.php?start=11",
    Comments: "Registration is optional for petroleum engineers."
  },
  {
    State: "Bolivia",
    Applicable: "",
    StateWebsite: "All",
    ApplyWebsite: "https://www.sib.org.bo/; https://cipsantacruz.com/",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Brazil",
    Applicable: "",
    StateWebsite: "All",
    ApplyWebsite: "",
    LicensingBoard: "",
    Comments: "No website found"
  },
  {
    State: "Chile",
    Applicable: "",
    StateWebsite: "All",
    ApplyWebsite: "https://www.ingenieros.cl/",
    LicensingBoard: "https://www.ingenieros.cl/",
    Comments: ""
  },
  {
    State: "Colombia",
    Applicable: "Y",
    StateWebsite: "All",
    ApplyWebsite: "https://www.cpip.gov.co/index.php/matriculas/",
    LicensingBoard: "https://www.cpip.gov.co",
    Comments: "Consejo Profesional de Ingeniería de Petróleos (CPIP). “Matrícula Profesional” required."
  },
  {
    State: "Costa Rica",
    Applicable: "",
    StateWebsite: "All",
    ApplyWebsite: "",
    LicensingBoard: "",
    Comments: "No website found"
  },
  {
    State: "Cuba",
    Applicable: "",
    StateWebsite: "All",
    ApplyWebsite: "",
    LicensingBoard: "",
    Comments: "No website found"
  },
  {
    State: "Dominican Republic",
    Applicable: "",
    StateWebsite: "All",
    ApplyWebsite: "",
    LicensingBoard: "",
    Comments: "No website found"
  },
  {
    State: "Ecuador",
    Applicable: "",
    StateWebsite: "All",
    ApplyWebsite: "https://cigmipa.net/",
    LicensingBoard: "https://cigmipa.net/",
    Comments: ""
  },
  {
    State: "El Salvador",
    Applicable: "",
    StateWebsite: "All",
    ApplyWebsite: "https://cig.org.gt/index.html",
    LicensingBoard: "",
    Comments: "No website found"
  },
  {
    State: "Guatemala",
    Applicable: "Y",
    StateWebsite: "https://cig.org.gt/index.html",
    ApplyWebsite: "COLEGIO DE INGENIEROS DE GUATEMALA (cig.org.gt)",
    LicensingBoard: "",
    Comments: "Must be approved by Colegio de Ingenieros if your degree is from a recognized uni."
  },
  {
    State: "Haiti",
    Applicable: "",
    StateWebsite: "All",
    ApplyWebsite: "",
    LicensingBoard: "",
    Comments: "No website found"
  },
  {
    State: "Honduras",
    Applicable: "",
    StateWebsite: "All",
    ApplyWebsite: "",
    LicensingBoard: "",
    Comments: "No website found"
  },
  {
    State: "Mexico",
    Applicable: "Y",
    StateWebsite: "All",
    ApplyWebsite: "https://cipm.org.mx/",
    LicensingBoard: "https://connect.spe.org/mexico/inicio",
    Comments: "Colegio de Ingenieros Petroleros de Mexico, SPE. Also see SPE certification link."
  },
  {
    State: "Nicaragua",
    Applicable: "",
    StateWebsite: "All",
    ApplyWebsite: "",
    LicensingBoard: "",
    Comments: "No website found"
  },
  {
    State: "Panama",
    Applicable: "",
    StateWebsite: "All",
    ApplyWebsite: "",
    LicensingBoard: "",
    Comments: "No website found"
  },
  {
    State: "Paraguay",
    Applicable: "",
    StateWebsite: "All",
    ApplyWebsite: "",
    LicensingBoard: "",
    Comments: "No website found"
  },
  {
    State: "Peru",
    Applicable: "Y",
    StateWebsite: "https://www.cip.org.pe/",
    ApplyWebsite: "Inicio - Colegio de Ingenieros del Perú (cip.org.pe)",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Puerto Rico (Latin America list)",
    Applicable: "",
    StateWebsite: "https://www.estado.pr.gov/juntas-examinadoras/ingenieros-y-agrimensores-de-puerto-rico",
    ApplyWebsite: "https://pr.pcshq.com/?page=ingenierosyagrimensores,PReng-license",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Uruguay",
    Applicable: "",
    StateWebsite: "All",
    ApplyWebsite: "",
    LicensingBoard: "",
    Comments: "No website found"
  },
  {
    State: "Venezuela",
    Applicable: "",
    StateWebsite: "http://www.civ.net.ve/",
    ApplyWebsite: "http://www.civ.net.ve/",
    LicensingBoard: "",
    Comments: "No extra certification unless working directly with Venezuelan State."
  },
  {
    State: "French Guiana",
    Applicable: "",
    StateWebsite: "All",
    ApplyWebsite: "",
    LicensingBoard: "",
    Comments: "No website found"
  },
  {
    State: "Guyana",
    Applicable: "",
    StateWebsite: "",
    ApplyWebsite: "https://www.facebook.com/Guyana-Association-of-Professional-Engineers-GAPE-122935717756329/",
    LicensingBoard: "https://www.stabroeknews.com/2020/09/05/news/guyana/gape-urges-edghill-to-consider-engineers-registration-bill/",
    Comments: "No official registration yet; GAPE proposed a bill in 2020."
  },

  // ------------------------
  // Russia / Central Asia
  // ------------------------
  {
    State: "Russia",
    Applicable: "NA",
    StateWebsite: "",
    ApplyWebsite: "https://www.gkz-rf.ru/ ; https://minenergo.gov.ru/",
    LicensingBoard: "",
    Comments: "No PE licensing. Ministry of Energy & State Committee of Reserves websites provided."
  },
  {
    State: "Kazakhstan",
    Applicable: "NA",
    StateWebsite: "",
    ApplyWebsite: "https://www.gov.kz/memleket/entities/energo?lang=en ; https://www.gov.kz/memleket/entities/geology?lang=ru ; http://www.iacng.kz/ru/about/about.php",
    LicensingBoard: "",
    Comments: "No PE licensing. Useful sites for Ministry of Energy & Geological Committee."
  },
  {
    State: "Uzbekistan",
    Applicable: "NA",
    StateWebsite: "",
    ApplyWebsite: "https://minenergy.uz/ru ; https://www.uzgeolcom.uz/uz",
    LicensingBoard: "",
    Comments: "No PE licensing. Websites for Ministry of Energy & Geological Committee."
  },
  {
    State: "Turkmenistan",
    Applicable: "NA",
    StateWebsite: "",
    ApplyWebsite: "https://www.minenergo.gov.tm/",
    LicensingBoard: "",
    Comments: "No PE licensing. Ministry of Energy website for reference."
  },
  {
    State: "Tajikistan",
    Applicable: "NA",
    StateWebsite: "",
    ApplyWebsite: "https://www.mewr.tj/ ; http://www.gst.tj/ru/gosudarstvennaya-komissiya-po-zapasam-poleznykh-iskopaemykh.html",
    LicensingBoard: "",
    Comments: "No PE licensing. Websites for Min of Energy & State Committee of Reserves."
  },
  {
    State: "Kyrgyzstan",
    Applicable: "NA",
    StateWebsite: "",
    ApplyWebsite: "http://www.mep.kg/ ; http://geology.kg",
    LicensingBoard: "",
    Comments: "No PE licensing. Ministry of Energy & Geology sites provided."
  },

  // (Email placeholders from your data omitted or placed in comments if needed)
  // ...

  // ------------------------
  // Middle East / MENA (additional)
  // ------------------------
  {
    State: "Afghanistan",
    Applicable: "",
    StateWebsite: "",
    ApplyWebsite: "",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Egypt (MENA block)",
    Applicable: "NA",
    StateWebsite: "http://eea.org.eg/ ; https://www.petroleum.gov.eg/en/Pages/HomePage.aspx",
    ApplyWebsite: "",
    LicensingBoard: "",
    Comments: "No formal PE licensing. Engineers are registered in Egyptian Engineering Syndicate."
  },
  {
    State: "Iran",
    Applicable: "",
    StateWebsite: "",
    ApplyWebsite: "",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Iraq",
    Applicable: "",
    StateWebsite: "",
    ApplyWebsite: "",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Mongolia (duplicate in MENA block?)",
    Applicable: "",
    StateWebsite: "",
    ApplyWebsite: "",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Pakistan (MENA block)",
    Applicable: "Y",
    StateWebsite: "https://www.pec.org.pk/",
    ApplyWebsite: "https://portal.pec.org.pk/",
    LicensingBoard: "http://www.mpnr.gov.pk/",
    Comments: "PE required for gov engineering jobs. Ministry of Energy website also provided."
  },
  {
    State: "Turkey (MENA block)",
    Applicable: "",
    StateWebsite: "",
    ApplyWebsite: "",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Ukraine",
    Applicable: "NA",
    StateWebsite: "https://www.dkz.gov.ua/en ; http://mpe.kmu.gov.ua/",
    ApplyWebsite: "",
    LicensingBoard: "",
    Comments: "No licensing. Ministry of Energy & State Committee of Reserves references."
  },

  // ------------------------
  // Additional U.S. entries (expanded)
  // ------------------------
  {
    State: "Alabama (expanded)",
    Applicable: "",
    StateWebsite: "https://www.alabama.gov/",
    ApplyWebsite: "https://bels.alabama.gov/",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Alaska (expanded)",
    Applicable: "",
    StateWebsite: "https://alaska.gov/",
    ApplyWebsite: "https://www.commerce.alaska.gov/web/cbpl/ProfessionalLicensing/BoardofArchitectsEngineersandLandSurveyors.aspx",
    LicensingBoard: "https://my.alaska.gov/adfs/ls/?wa=wsignin1.0&wtrealm=https%3a%2f%2fwww.commerce.alaska.gov%2fcbp%2fmain%2fsecure%2f&wctx=rm%3d0%26id%3dpassive%26ru%3d%252fcbp%252fmain%252fsecure%252f&wct=2020-01-02T14%3a57%3a02Z&pubid=CBPLMain",
    Comments: ""
  },
  {
    State: "Samoa (a.k.a. American Samoa)",
    Applicable: "",
    StateWebsite: "https://www.americansamoa.gov/",
    ApplyWebsite: "This U.S. territory is the only jurisdiction that doesn't license professional engineers",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Arizona (expanded)",
    Applicable: "",
    StateWebsite: "https://az.gov/",
    ApplyWebsite: "https://btr.az.gov/engineer-applicants",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Arkansas",
    Applicable: "",
    StateWebsite: "https://portal.arkansas.gov/",
    ApplyWebsite: "https://www.pels.arkansas.gov/",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "California",
    Applicable: "",
    StateWebsite: "https://www.ca.gov/",
    ApplyWebsite: "https://www.bpelsg.ca.gov/applicants/appinstpe.shtml",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Colorado",
    Applicable: "",
    StateWebsite: "https://www.colorado.gov/",
    ApplyWebsite: "https://dpo.colorado.gov/AES",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Connecticut",
    Applicable: "",
    StateWebsite: "https://portal.ct.gov/",
    ApplyWebsite: "https://portal.ct.gov/DCP/Occupational-and-Professional-Division/Occupational-Boards/State-Board-of-Examiners-for-Professional-Engineers-and-Land-Surveyors",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Delaware",
    Applicable: "",
    StateWebsite: "https://delaware.gov/",
    ApplyWebsite: "https://www.dape.org/",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "District of Columbia",
    Applicable: "",
    StateWebsite: "https://dc.gov/",
    ApplyWebsite: "https://dcra.dc.gov/engineers",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Florida",
    Applicable: "",
    StateWebsite: "http://www.myflorida.com/",
    ApplyWebsite: "https://fbpe.org/",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Georgia (U.S.)",
    Applicable: "",
    StateWebsite: "https://georgia.gov/",
    ApplyWebsite: "https://sos.ga.gov/index.php/licensing/plb/22",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Guam",
    Applicable: "",
    StateWebsite: "https://www.guam.gov/",
    ApplyWebsite: "https://www.guam-peals.org/",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Hawaii",
    Applicable: "",
    StateWebsite: "https://portal.ehawaii.gov/",
    ApplyWebsite: "http://cca.hawaii.gov/pvl/",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Idaho",
    Applicable: "",
    StateWebsite: "https://www.idaho.gov/",
    ApplyWebsite: "https://ipels.idaho.gov/",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Illinois",
    Applicable: "",
    StateWebsite: "",
    ApplyWebsite: "https://www.idfpr.com/profs/ProfEngineer.asp",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Indiana",
    Applicable: "",
    StateWebsite: "https://www.in.gov/core/",
    ApplyWebsite: "https://www.in.gov/pla/professions/state-board-of-registration-for-professional-engineers/",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Iowa",
    Applicable: "",
    StateWebsite: "https://www.iowa.gov/",
    ApplyWebsite: "https://plb.iowa.gov/board/engineers-land-surveyors",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Kansas",
    Applicable: "",
    StateWebsite: "https://portal.kansas.gov/",
    ApplyWebsite: "https://www.ksbtp.ks.gov/professions/engineers",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Kentucky",
    Applicable: "",
    StateWebsite: "https://kentucky.gov/Pages/home.aspx",
    ApplyWebsite: "https://kyboels.ky.gov/Pages/default.aspx",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Louisiana",
    Applicable: "",
    StateWebsite: "https://www.louisiana.gov/",
    ApplyWebsite: "http://www.lapels.com/",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Maine",
    Applicable: "",
    StateWebsite: "https://www.maine.gov/portal/index.html",
    ApplyWebsite: "https://www.maine.gov/professionalengineers/",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Maryland",
    Applicable: "",
    StateWebsite: "https://www.maryland.gov/Pages/default.aspx",
    ApplyWebsite: "http://www.dllr.state.md.us/license/pe/peaff.shtml",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Massachusetts",
    Applicable: "",
    StateWebsite: "https://www.mass.gov/",
    ApplyWebsite: "https://www.mass.gov/orgs/board-of-registration-of-professional-engineers-and-land-surveyors",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Michigan",
    Applicable: "",
    StateWebsite: "https://www.michigan.gov/",
    ApplyWebsite: "https://www.michigan.gov/lara/0,4601,7-154-89334_72600_72602_72731_72865---,00.html",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Minnesota",
    Applicable: "",
    StateWebsite: "https://mn.gov/portal/",
    ApplyWebsite: "https://mn.gov/aelslagid/engineering.html",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Mississippi",
    Applicable: "",
    StateWebsite: "https://www.ms.gov/home",
    ApplyWebsite: "https://www.pepls.ms.gov/",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Missouri",
    Applicable: "",
    StateWebsite: "https://www.mo.gov/",
    ApplyWebsite: "https://pr.mo.gov/apelsla.asp",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Montana",
    Applicable: "",
    StateWebsite: "https://mt.gov/",
    ApplyWebsite: "https://boards.bsd.dli.mt.gov/professional-engineers-land-surveyors/",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Nebraska",
    Applicable: "",
    StateWebsite: "https://www.nebraska.gov/",
    ApplyWebsite: "https://ea.nebraska.gov/",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Nevada",
    Applicable: "",
    StateWebsite: "https://nv.gov/",
    ApplyWebsite: "https://nvbpels.org/professionals/engineers/",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "New Hampshire",
    Applicable: "",
    StateWebsite: "https://www.nh.gov/index.htm",
    ApplyWebsite: "https://www.oplc.nh.gov/engineers/",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "New Jersey",
    Applicable: "",
    StateWebsite: "https://www.state.nj.us/",
    ApplyWebsite: "https://www.njconsumeraffairs.gov/pels/",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "New Mexico",
    Applicable: "",
    StateWebsite: "http://www.newmexico.gov/",
    ApplyWebsite: "https://www.sblpes.state.nm.us/",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "New York",
    Applicable: "",
    StateWebsite: "https://www.ny.gov/",
    ApplyWebsite: "http://www.op.nysed.gov/prof/pels/pelic.htm",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "North Carolina",
    Applicable: "",
    StateWebsite: "https://www.nc.gov/",
    ApplyWebsite: "https://www.ncbels.org/",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "North Dakota",
    Applicable: "",
    StateWebsite: "https://www.nd.gov/",
    ApplyWebsite: "https://ndpelsboard.org/",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Commonwealth of the Northern Marianas Islands",
    Applicable: "",
    StateWebsite: "https://www.doi.gov/oia/islands/cnmi",
    ApplyWebsite: "https://engineer-educators.com/northern-mariana-islands-board-professional-licensing/",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Ohio",
    Applicable: "",
    StateWebsite: "https://ohio.gov/wps/portal/gov/site/home",
    ApplyWebsite: "https://peps.ohio.gov/wps/portal/gov/peps/",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Oklahoma",
    Applicable: "",
    StateWebsite: "https://oklahoma.gov/",
    ApplyWebsite: "https://www.ok.gov/pels/",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Oregon",
    Applicable: "",
    StateWebsite: "https://www.oregon.gov/pages/index.aspx",
    ApplyWebsite: "https://www.oregon.gov/OSBEELS/Pages/default.aspx",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Pennsylvania",
    Applicable: "",
    StateWebsite: "https://www.pa.gov/",
    ApplyWebsite: "https://www.dos.pa.gov/ProfessionalLicensing/BoardsCommissions/EngineersLandSurveyorsandGeologists/Pages/default.aspx",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Puerto Rico",
    Applicable: "",
    StateWebsite: "https://www2.pr.gov/Pages/default.aspx",
    ApplyWebsite: "https://www.estado.pr.gov/en/engineers-and-surveyors/",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Rhode Island",
    Applicable: "",
    StateWebsite: "https://www.ri.gov/",
    ApplyWebsite: "http://www.bdp.ri.gov/engineers/applications.php",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "South Carolina",
    Applicable: "",
    StateWebsite: "https://sc.gov/",
    ApplyWebsite: "https://llr.sc.gov/",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "South Dakota",
    Applicable: "",
    StateWebsite: "https://sd.gov/",
    ApplyWebsite: "https://dlr.sd.gov/btp/default.aspx",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Tennessee",
    Applicable: "",
    StateWebsite: "https://www.tn.gov/",
    ApplyWebsite: "https://www.tn.gov/commerce/regboards/architects-engineers.html",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Texas",
    Applicable: "",
    StateWebsite: "https://www.texas.gov/",
    ApplyWebsite: "https://pels.texas.gov/",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Utah",
    Applicable: "",
    StateWebsite: "https://www.utah.gov/index.html",
    ApplyWebsite: "https://dopl.utah.gov/",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Vermont",
    Applicable: "",
    StateWebsite: "https://www.vermont.gov/#gsc.tab=0",
    ApplyWebsite: "https://sos.vermont.gov/engineering/",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Virginia",
    Applicable: "",
    StateWebsite: "https://www.virginia.gov/",
    ApplyWebsite: "https://www.dpor.virginia.gov/Boards/APELS/",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "U.S. Virgin Islands",
    Applicable: "",
    StateWebsite: "https://www.vi.gov/",
    ApplyWebsite: "https://dlca.vi.gov/boardcertifications/steps/aelrequirements/requirements.htm",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Washington",
    Applicable: "",
    StateWebsite: "https://access.wa.gov/",
    ApplyWebsite: "https://www.dol.wa.gov/business/engineerslandsurveyors/",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "West Virginia",
    Applicable: "",
    StateWebsite: "https://www.wv.gov/Pages/default.aspx#home",
    ApplyWebsite: "https://www.wvpebd.org/",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Wisconsin",
    Applicable: "",
    StateWebsite: "https://www.wisconsin.gov/Pages/Home.aspx",
    ApplyWebsite: "https://dsps.wi.gov/pages/BoardsCouncils/AE/Default.aspx",
    LicensingBoard: "",
    Comments: ""
  },
  {
    State: "Wyoming (expanded)",
    Applicable: "",
    StateWebsite: "https://www.wyo.gov/",
    ApplyWebsite: "https://engineersandsurveyors.wyo.gov/",
    LicensingBoard: "",
    Comments: ""
  },

  // ------------------------
  // Canada
  // ------------------------
  {
    State: "Alberta",
    Applicable: "Y",
    StateWebsite: "https://www.alberta.ca/office-statistics-information.aspx",
    ApplyWebsite: "https://www.apega.ca/",
    LicensingBoard: "https://www.apega.ca/apply/membership",
    Comments: ""
  },
  {
    State: "British Columbia",
    Applicable: "Y",
    StateWebsite: "http://www.bcstats.gov.bc.ca/",
    ApplyWebsite: "http://www.apeg.bc.ca/",
    LicensingBoard: "https://www.egbc.ca/Registration/Individual-Registrants/How-to-Apply",
    Comments: ""
  },
  {
    State: "Manitoba",
    Applicable: "Y",
    StateWebsite: "http://www.gov.mb.ca/mbs/",
    ApplyWebsite: "http://www.apegm.mb.ca/",
    LicensingBoard: "http://www.apegm.mb.ca/ProfessionalMembership.html",
    Comments: ""
  },
  {
    State: "New Brunswick",
    Applicable: "Y",
    StateWebsite: "http://www2.gnb.ca/content/gnb/en/departments/finance.html",
    ApplyWebsite: "https://www.apegnb.com/",
    LicensingBoard: "https://www.apegnb.com/registration/first-time-applicant-in-canada-internationally-trained-or-other/",
    Comments: ""
  },
  {
    State: "Newfoundland and Labrador",
    Applicable: "Y",
    StateWebsite: "http://www.stats.gov.nl.ca/",
    ApplyWebsite: "http://www.pegnl.ca/",
    LicensingBoard: "https://www.pegnl.ca/LicensingRegistration/CategoriesQualifications.php",
    Comments: ""
  },
  {
    State: "Nova Scotia",
    Applicable: "Y",
    StateWebsite: "http://www.novascotia.ca/finance/statistics/",
    ApplyWebsite: "http://www.engineersnovascotia.ca/",
    LicensingBoard: "https://engineersnovascotia.ca/registration/",
    Comments: ""
  },
  {
    State: "Ontario",
    Applicable: "Y",
    StateWebsite: "http://www.fin.gov.on.ca/en/index.html",
    ApplyWebsite: "http://www.peo.on.ca/",
    LicensingBoard: "https://www.peo.on.ca/licence-applications/become-professional-engineer",
    Comments: ""
  },
  {
    State: "Prince Edward Island",
    Applicable: "Y",
    StateWebsite: "http://www.gov.pe.ca/pt/esaffr-info/dg.inc.php3",
    ApplyWebsite: "http://www.engineerspei.com/",
    LicensingBoard: "https://www.engineerspei.com/node/135",
    Comments: ""
  },
  {
    State: "Quebec",
    Applicable: "Y",
    StateWebsite: "http://www.stat.gouv.qc.ca/default_an.html",
    ApplyWebsite: "http://oiq.qc.ca/Pages/accueil.aspx?lang=en",
    LicensingBoard: "http://www.oiq.qc.ca/fr/jeSuis/candidat/Pages/default.aspx",
    Comments: ""
  },
  {
    State: "Saskatchewan",
    Applicable: "Y",
    StateWebsite: "http://www.saskatchewan.ca/government/government-data/bureau-of-statistics",
    ApplyWebsite: "http://www.apegs.ca/",
    LicensingBoard: "https://www.apegs.ca/apply/how-to-apply",
    Comments: ""
  },
  {
    State: "Northwest Territories",
    Applicable: "Y",
    StateWebsite: "http://www.statsnwt.ca/",
    ApplyWebsite: "http://www.napeg.nt.ca/",
    LicensingBoard: "https://www.napeg.nt.ca/registration/categories/",
    Comments: ""
  },
  {
    State: "Nunavut",
    Applicable: "Y",
    StateWebsite: "http://www.stats.gov.nu.ca/en/home.aspx",
    ApplyWebsite: "http://www.napeg.nt.ca/",
    LicensingBoard: "https://www.napeg.nt.ca/registration/categories/",
    Comments: ""
  },
  {
    State: "Yukon",
    Applicable: "Y",
    StateWebsite: "https://yukon.ca/en/bureau-of-statistics",
    ApplyWebsite: "http://www.apey.yk.ca/",
    LicensingBoard: "https://engineersyukon.ca/application-for-membership.php",
    Comments: ""
  }
];

/**
 * fetchData - calls the Cloudflare Worker GET /fetch-array to retrieve all docs
 * from the "array" collection in Firestore, merges them onto the local licensingData.
 */
export async function fetchData(): Promise<LicensingInfo[]> {
  try {
    const resp = await fetch("https://speemap.ryanhardestylewis.workers.dev/fetch-array");
    if (!resp.ok) {
      console.error("Failed to fetch from /fetch-array:", resp.status);
      return licensingData; // fallback
    }

    // Suppose the worker returns an array of objects like:
    // [ { State: "Alabama", Applicable: "...", ... }, { State: "Alaska", ... } ]
    const remoteDocs: Partial<LicensingInfo>[] = await resp.json();

    // We'll clone the local data so we can merge in place
    const merged = [...licensingData];

    for (const doc of remoteDocs) {
      if (!doc.State) continue; // must have a State name
      const idx = merged.findIndex(
        (x) => x.State.toLowerCase() === doc.State.toLowerCase()
      );
      if (idx >= 0) {
        // For each field that exists in doc, override
        if (typeof doc.Applicable === "string") {
          merged[idx].Applicable = doc.Applicable;
        }
        if (typeof doc.StateWebsite === "string") {
          merged[idx].StateWebsite = doc.StateWebsite;
        }
        if (typeof doc.ApplyWebsite === "string") {
          merged[idx].ApplyWebsite = doc.ApplyWebsite;
        }
        if (typeof doc.LicensingBoard === "string") {
          merged[idx].LicensingBoard = doc.LicensingBoard;
        }
        if (typeof doc.Comments === "string") {
          merged[idx].Comments = doc.Comments;
        }
      } else {
        // If we want to add new states not in the base array
        // We'll fill missing fields with empty strings or "N/A"
        // e.g.:
        const newItem: LicensingInfo = {
          State: doc.State,
          Applicable: doc.Applicable ?? "",
          StateWebsite: doc.StateWebsite ?? "",
          ApplyWebsite: doc.ApplyWebsite ?? "",
          LicensingBoard: doc.LicensingBoard ?? "",
          Comments: doc.Comments ?? ""
        };
        merged.push(newItem);
      }
    }

    return merged;
  } catch (err) {
    console.error("Error in fetchData:", err);
    return licensingData; // fallback
  }
}


/**
 * GOOGLE_API_URL from your code snippet, which includes:
 *   - The spreadsheet ID: 1-pdpGcumwThIecsnzkUcw8OnfV7rdC6or8AtPm1OGnk
 *   - The range/sheet name: Sheet1
 *   - The public API key: AIzaSyCeQWoca... (public for read-only)
 */
const GOOGLE_API_URL = 
"https://sheets.googleapis.com/v4/spreadsheets/1-pdpGcumwThIecsnzkUcw8OnfV7rdC6or8AtPm1OGnk/values/Sheet1?key=AIzaSyCeQWocaHm-x91B8-f0ymF66CJhFKj5G_0";

/**
* loadLicensingDataFromGoogleSheet()
* ----------------------------------
* Reads data from the new Google Sheets v4 endpoint (published sheet).
* The JSON structure looks like:
* {
*   range: "Sheet1!A1:Z1000",
*   majorDimension: "ROWS",
*   values: [
*     [ "State", "Applicable", "StateWebsite", "ApplyWebsite", "LicensingBoard", "Comments" ],
*     [ "Alabama", "", "https://www.alabama.gov/", "https://bels.alabama.gov/", ... ],
*     ...
*   ]
* }
*/
export async function loadLicensingDataFromGoogleSheet(): Promise<LicensingInfo[]> {
try {
  const resp = await fetch(GOOGLE_API_URL);
  if (!resp.ok) {
    throw new Error(
      `Google Sheets API responded with status ${resp.status} - ${resp.statusText}`
    );
  }

  const data = await resp.json();
  if (!data.values || !Array.isArray(data.values) || data.values.length < 2) {
    // If there's no data or just the header row, fallback
    console.warn("No valid rows found in sheet data. Falling back to local data.");
    return licensingData;
  }

  const rows: string[][] = data.values; // array of string arrays
  // First row is the header: ["State", "Applicable", "StateWebsite", "ApplyWebsite", "LicensingBoard", "Comments"]
  const header = rows[0];
  const dataRows = rows.slice(1); // all rows except the first

  // Identify the column indices we care about
  const colMap = {
    State: header.indexOf("State"),
    Applicable: header.indexOf("Applicable"),
    StateWebsite: header.indexOf("StateWebsite"),
    ApplyWebsite: header.indexOf("ApplyWebsite"),
    LicensingBoard: header.indexOf("LicensingBoard"),
    Comments: header.indexOf("Comments")
  };

  // Build our LicensingInfo[] from the dataRows
  const result: LicensingInfo[] = dataRows.map((rowArr) => ({
    State: rowArr[colMap.State] || "",
    Applicable: rowArr[colMap.Applicable] || "",
    StateWebsite: rowArr[colMap.StateWebsite] || "",
    ApplyWebsite: rowArr[colMap.ApplyWebsite] || "",
    LicensingBoard: rowArr[colMap.LicensingBoard] || "",
    Comments: rowArr[colMap.Comments] || ""
  }));

  return result;
} catch (err) {
  console.error("Error loading from Google Sheets API:", err);
  // If anything goes wrong, return local licensingData
  return licensingData;
}
}